import { RentalOrUnoccupied } from "../houseTypes";

export const isRental = (rentalOrUnoccupied: RentalOrUnoccupied): boolean =>
  isFullRental(rentalOrUnoccupied) || isPartialRental(rentalOrUnoccupied);

export const isFullRental = (
  rentalOrUnoccupied: RentalOrUnoccupied | undefined,
): boolean => rentalOrUnoccupied === RentalOrUnoccupied.FULL_RENTAL;

export const isPartialRental = (
  rentalOrUnoccupied: RentalOrUnoccupied | undefined,
): boolean => rentalOrUnoccupied === RentalOrUnoccupied.PARTIAL_RENTAL;

export const isHouseUnoccupied = (
  rentalOrUnoccupied: RentalOrUnoccupied,
): boolean => rentalOrUnoccupied === RentalOrUnoccupied.UNOCCUPIED;
